<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <div>{{ username }}</div>
    </template>
    <template slot="dropdown">
      <b-dropdown-item @click="clickLogout()"><i class="fa fa-sign-out" /> 退出</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import axios from 'axios'
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'

export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data () {
    return {
      username: this.$root.userInfo.username,
      backendUrl: axios.backendUrl
    }
  },
  mounted() {
this.username = this.$root.userInfo.username
  },
  created() {
    this.username = this.$root.userInfo.username
  },
  methods: {
    clickLogout() {
      axios.get(this.backendUrl + '/logout').then(response => {
      }).catch(error => {
        
      })
    }
  }
}
</script>
